<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="dedication" role="doc-dedication">
<p class="sp"> </p>
<p class="DED"><i>To my father, Willie Howard Mays, Sr., who taught me about life, and to the people of Fairfield, Alabama, who helped raise me.</i></p>
<p class="DEDAU">—Willie Mays</p>
<p class="DED"><i>To my daughter, Tereza, my wife, Zdena, and the memory of my mother, Ann. Three generations of inspirations.</i></p>
<p class="DEDAU">—John Shea</p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?3faa82c7